import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  BoxFull,
  Button,
  TransactionalSubheader,
} from "iuvity-ui-components";
import { Header } from "../../components";
import {
  CustomDialog,
  DialogProps,
} from "../../components/dialog/CustomDialog";
import { AppContext } from "../../context/index";
import { REVALIDATE_FORM_PROPS, infoRoleDetailFields } from "../../constants";
import { UsersSchema } from "../../validations/schemas";
import { CustomFormComponent } from "../../components/shared/CustomFormComponent";

export const DetailRolePage = () => {
  const navigate = useNavigate();
  const {
    t,
    appState: { user, selectedRole },
    setAppState,
  } = useContext(AppContext);

  const form = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues: 
      {
        id: selectedRole?.id,
        name: selectedRole?.name,
        roleTypeId: selectedRole?.roleTypeId,
        expeditionDate: selectedRole?.expeditionDate,
        expirationDate: selectedRole?.expirationDate,
      }
  });

  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const onReturn = () => {
    setAppState((prev) => ({
      ...prev,
      selectedConfig: null,
    }));
    navigate('/users');
    window.scrollTo(0, 0);
  };

  const readOnlyObject = {
    name: true,
    roleTypeId: true,
    expeditionDate: true,
    expirationDate: true,
  };
  
  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}

      <TransactionalSubheader
        subheaderTitle={
          <div className="flex align-items-center" style={{ position: "relative", left: "-40px" }}>
            <i
              className="iu iu-icon-left pr-3"
              onClick={() => navigate(-1)}
              aria-hidden="true"
              style={{
                fontSize: "var(--font-size-tablet-title)",
                cursor: "pointer",
              }}
            />
            {t("Users.detailRoleTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("MappedFields.mappedFieldsTitle")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate(-1),
          }}
          breadcrumbsItems={[
            {
              label: t("Users.usersBreadcrum"),
              disabled: true
            },
            {
              label: t("Users.usersTitle"),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
              command: () => onReturn(),
            },
            {
              label: t("Users.newTitle"),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
              command: () => navigate(-1),
            },
            {
              label: t("Users.detailRoleTitle"),
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
      </TransactionalSubheader>

      {/* <BoxFull className="my-4 p-0" style={{ backgroundColor: "transparent" }}>
        <div className="mx-5">
          <div className="t-subheader-content" style={{ margin: "2.5rem 0 0" }}>
            <span>{t(`Users.usersEditDescription`)}</span>
          </div>
        </div>
      </BoxFull> */}

      <CustomFormComponent
      functionality="Users"
      fields={infoRoleDetailFields}
      form={form}
      schemaOfValidation={UsersSchema}
      // dropdownOptions={formKeysOptions}
      REVALIDATE_FORM_PROPS={REVALIDATE_FORM_PROPS}
      readOnlyObject={readOnlyObject}
      />

      <BoxFull className="mt-0 mb-3 px-5 py-0" style={{ backgroundColor: "transparent" }}>
        <div className="flex align-items-center justify-content-end gap-4">
          <Button
            variant="p-button-link"
            label={t("Users.cancelBtnLabel")}
            // onClick={}
          />
          <Button
            variant="p-button"
            label={t("Users.saveChangesBtnLabel")}
            // onClick={}
          />
        </div>
      </BoxFull>

      <CustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </>
  );
};
